













import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'myFooter'
})
export default class MyFooter extends Vue {
  get thisYear (): number {
    return new Date().getFullYear()
  }

  handleIcp (): void {
    window.open('https://beian.miit.gov.cn/')
  }
}
